module.exports = __webpack_public_path__ + "static/WEDDING E&M-504-4676ea5fd3d4caadef9d3ed726e86a5c.jpg";